"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useUpdatePayment = void 0;
const tslib_1 = require("tslib");
/*
Copyright (C) 2009 - 2021 Broadleaf Commerce.

Licensed under the Broadleaf End User License Agreement (EULA),
Version 1.1 (the “Commercial License” located at
http://license.broadleafcommerce.org/commercial_license-1.1.txt).

Alternatively, the Commercial License may be replaced with a mutually
agreed upon license (the “Custom License”) between you and
Broadleaf Commerce. You may not use this file except in compliance
with the applicable license.
*/
const react_1 = require("react");
const axios_1 = (0, tslib_1.__importDefault)(require("axios"));
const internal_1 = require("./internal");
/**
 * This hook creates a callback to handle submitting a PaymentRequest to update an existing payment.
 */
const useUpdatePayment = (props) => {
    const { paymentClient, authState, rejectOnError = false } = props;
    const [error, setError] = (0, react_1.useState)();
    const getCustomerToken = (0, internal_1.useGetCustomerAccessToken)({ authState });
    const updatePayment = (0, react_1.useCallback)((paymentId, version, updatePaymentRequest) => (0, tslib_1.__awaiter)(void 0, void 0, void 0, function* () {
        var _a, _b;
        try {
            const accessToken = yield getCustomerToken();
            const response = yield paymentClient.updatePayment(paymentId, updatePaymentRequest, {
                version,
                accessToken
            });
            setError(undefined);
            return response;
        }
        catch (error) {
            if (axios_1.default.isCancel(error)) {
                // do nothing if cancelled
                return;
            }
            if (axios_1.default.isAxiosError(error)) {
                setError((_a = error.response) === null || _a === void 0 ? void 0 : _a.data);
                if (rejectOnError && error.response) {
                    throw (_b = error.response) === null || _b === void 0 ? void 0 : _b.data;
                }
            }
            // for some reason, we got some other kind of error than what we expected
            setError(error);
            if (rejectOnError) {
                throw error;
            }
            return;
        }
    }), [paymentClient, getCustomerToken, rejectOnError]);
    return { updatePayment, error };
};
exports.useUpdatePayment = useUpdatePayment;
//# sourceMappingURL=use-update-payment.js.map